/* ================================================== */
/* ACCESSIBILITY > Open Link Button
/* ================================================== */

$(document).ready(function() {
	$('a[role="button"][tabindex="0"]').keypress(function(event) {
		if (event.keyCode === 13) $(this).click();
	});
});